import React from 'react'
import { Link } from 'react-router-dom'

export const ButtonContent = ({ btnName, btnphone, btnStyle, btnLink }) => {
    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    return (
        btnphone ?
            <a
                className={`
                boton
                my-3
                ${btnStyle}
                px-6
                py-4
                w-52
                rounded-lg
            `}
                href={`tel:+1${btnphone}`}
            >

                <span>
                    {btnphone}
                </span>
            </a>
            :
            // estilo de boton: one, two, three
            <Link
                className={`
                boton
                my-3
                ${btnStyle ? btnStyle : 'one'}
                px-6
                py-4
                w-52
                rounded-lg
            `}
                to={`/${btnName ? btnLink : 'contact'}`}
                onClick={goToTop}
            >
                <span className='capitalize'>
                    {btnName ? btnName : 'free estimate'}
                </span>
            </Link>
    )
}
